(function($){

    $.fn.slider = function(){

        var elem = $(this),
            viewLimit = 1;

        const init = function(){

            elem.slick({
                //centerMode: true,
                //centerPadding: '50px',
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                infinite: true,
                arrows: false,
                adaptiveHeight: false,
                /*responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '150px',
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '0px',
                            slidesToShow: 1
                        }
                    }
                ]*/

            });

        };

        init();

        return this;

    }

}(jQuery));